import type { TourTheme } from '@carboncopyco/types';
import { mainApi } from './mainApi';

export interface GetTourThemesArgs {
  organizationId: string;
}

export interface GetTourThemeArgs {
  organizationId: string;
  tourThemeId: string;
}

export interface CreateTourThemeArgs {
  organizationId: string;
  tourTheme: Pick<TourTheme, 'name' | 'tooltipConfig' | 'category'>;
}

export interface DeleteTourThemeArgs {
  organizationId: string;
  tourThemeId: number;
}

export interface UpdateTourThemeArgs {
  organizationId: string;
  tourThemeId: string;
  tourTheme: Partial<TourTheme>;
}

const tourThemeApi = mainApi.injectEndpoints({
  endpoints: (builder) => ({
    getTourThemes: builder.query<TourTheme[], GetTourThemesArgs>({
      query: ({ organizationId }) => ({
        url: `/api/${organizationId}/tour-theme/list`,
        method: 'GET',
      }),
      providesTags: ['TourThemes'],
    }),

    getTourTheme: builder.query<TourTheme, GetTourThemeArgs>({
      query: ({ organizationId, tourThemeId }) => ({
        url: `/api/${organizationId}/tour-theme/${tourThemeId}`,
        providesTags: (_, __, { tourThemeId }) => [
          { type: 'TourTheme', id: tourThemeId },
        ],
      }),
    }),

    createTourTheme: builder.mutation<TourTheme, CreateTourThemeArgs>({
      query: ({ organizationId, tourTheme }) => ({
        url: `/api/${organizationId}/tour-theme/new`,
        method: 'PUT',
        body: tourTheme,
      }),
      invalidatesTags: [{ type: 'TourThemes' }],
    }),

    updateTourTheme: builder.mutation<TourTheme, UpdateTourThemeArgs>({
      query: ({ organizationId, tourThemeId, tourTheme }) => ({
        url: `/api/${organizationId}/tour-theme/${tourThemeId}`,
        method: 'PUT',
        body: tourTheme,
      }),
      invalidatesTags: (_, __, { tourThemeId }) => [
        { type: 'TourThemes' },
        { type: 'TourTheme', id: tourThemeId },
      ],
    }),

    deleteTourTheme: builder.mutation<TourTheme, DeleteTourThemeArgs>({
      query: ({ organizationId, tourThemeId }) => ({
        url: `/api/${organizationId}/tour-theme/${tourThemeId}`,
        method: 'DELETE',
      }),
      invalidatesTags: (_, __, { tourThemeId }) => [
        { type: 'TourThemes' },
        { type: 'TourTheme', id: tourThemeId },
      ],
    }),
  }),
});

export const {
  useGetTourThemesQuery,
  useGetTourThemeQuery,
  useLazyGetTourThemeQuery,
  useCreateTourThemeMutation,
  useUpdateTourThemeMutation,
  useDeleteTourThemeMutation,
} = tourThemeApi;
